"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pager = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var SvgIcon_1 = __importDefault(require("@atg/icf-react-components/components/SvgIcon"));
var Theme_1 = require("@atg/icf-react-components/themes/Theme");
var Utilities_1 = require("icf-search-client-shared/lib/Utilities");
var react_1 = __importDefault(require("react"));
var react_jss_1 = require("react-jss");
var Contexts_1 = require("../Contexts");
var Hoverable_1 = require("../utilities/Hoverable");
var Ioc_1 = require("../utilities/Ioc");
var buttonSize = 40;
var flexCenter = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
};
var usePagerStyles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    footerWrapper: {
        marginTop: "24px",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
    },
    pagerButton: __assign(__assign({ width: buttonSize, height: buttonSize, backgroundColor: theme.mode === Theme_1.ThemeMode.dark ? theme.colors.baseContrast020 : theme.colors.themeBase, border: 0, borderRadius: "2px", color: "orange", cursor: "pointer" }, flexCenter), { "&:hover": {
            backgroundColor: theme.colors.primary,
        } }),
    pageLinkLabel: __assign(__assign({ color: theme.colors.baseContrast080, width: buttonSize, height: buttonSize, fontSize: "20px", fontWeight: 500, borderRadius: "50%" }, flexCenter), { margin: "0 2px", "&:hover": {
            backgroundColor: theme.mode === Theme_1.ThemeMode.dark ? theme.colors.baseContrast020 : theme.colors.themeBase,
        } }),
    currentPageLabel: __assign(__assign({ borderRadius: "50%", backgroundColor: theme.colors.primary, color: theme.colors.baseContrast010, width: buttonSize, height: buttonSize, fontSize: "20px", fontWeight: 500 }, flexCenter), { margin: "0 2px" }),
}); });
var Pager = function (props) {
    var classes = usePagerStyles();
    var _a = __read((0, Ioc_1.useContexts)(Contexts_1.ILinkComponentContext), 1), Link = _a[0];
    var currentPage = props.currentPage, getPageLinkTo = props.getPageLinkTo, onPageClick = props.onPageClick, onNextClick = props.onNextClick, onPrevClick = props.onPrevClick, pageRange = props.pageRange;
    var start = pageRange.start, end = pageRange.end;
    var LinkLeftComponent = (react_1.default.createElement(Link, { to: getPageLinkTo(currentPage - 1), onClick: function () { return onPrevClick(currentPage - 1); } },
        react_1.default.createElement(Hoverable_1.Hoverable, null, function (isHovering) { return (
        // eslint-disable-next-line @atg/css-rtl-support
        react_1.default.createElement("div", { className: classes.pagerButton, "data-ta-locator": "previous_action", style: { marginRight: "16px" } },
            react_1.default.createElement(SvgIcon_1.default, { size: 32, name: "chevronLeft", fill: isHovering ? "highContrast" : "primary" }))); })));
    var LinkRightComponent = (react_1.default.createElement(Link, { to: getPageLinkTo(currentPage + 1), onClick: function () { return onNextClick(currentPage + 1); } },
        react_1.default.createElement(Hoverable_1.Hoverable, null, function (isHovering) { return (
        // eslint-disable-next-line @atg/css-rtl-support
        react_1.default.createElement("div", { className: classes.pagerButton, "data-ta-locator": "next_action", style: { marginLeft: "16px" } },
            react_1.default.createElement(SvgIcon_1.default, { size: 32, name: "chevronRight", fill: isHovering ? "highContrast" : "primary" }))); })));
    return (react_1.default.createElement("div", { className: classes.footerWrapper, "data-ta-locator": "grid-pager" },
        react_1.default.createElement("div", null, currentPage > start && LinkLeftComponent),
        (0, Utilities_1.getNumberRange)(start, end - start + 1).map(function (pageNum) {
            var LinkComponent = (
            // @ts-ignore
            react_1.default.createElement(Link, { to: getPageLinkTo(pageNum), onClick: function () { return onPageClick(pageNum); }, key: "pager-" + pageNum },
                react_1.default.createElement("div", { className: classes.pageLinkLabel, "data-ta-locator": "pager-link-label" }, pageNum)));
            return pageNum === currentPage ? (react_1.default.createElement("div", { className: classes.currentPageLabel, "data-ta-locator": "pager-current-label", key: "pager-" + pageNum }, pageNum)) : (LinkComponent);
        }),
        react_1.default.createElement("div", null, currentPage < end && LinkRightComponent)));
};
exports.Pager = Pager;
exports.Pager.displayName = "Pager";
//# sourceMappingURL=Pager.js.map